/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weak`)
};

const es_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débil`)
};

const de_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwach`)
};

const nl_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwak`)
};

const fr_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const it_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debole`)
};

const pt_br2_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraca`)
};

const pt_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraca`)
};

const ja_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`弱い`)
};

const zh_pw_strength_weak = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`弱`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_strength_weak = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_strength_weak(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_strength_weak", locale)
	if (locale === "en") return en_pw_strength_weak(inputs)
	if (locale === "es") return es_pw_strength_weak(inputs)
	if (locale === "de") return de_pw_strength_weak(inputs)
	if (locale === "nl") return nl_pw_strength_weak(inputs)
	if (locale === "fr") return fr_pw_strength_weak(inputs)
	if (locale === "it") return it_pw_strength_weak(inputs)
	if (locale === "pt-BR") return pt_br2_pw_strength_weak(inputs)
	if (locale === "pt") return pt_pw_strength_weak(inputs)
	if (locale === "ja") return ja_pw_strength_weak(inputs)
	return zh_pw_strength_weak(inputs)
};